import { createLead } from "@/lib/backend";

// Analytics / dataLayer event hook (progressive — no-ops if no dataLayer)
export function track(event, payload = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload, ts: Date.now() });
    // eslint-disable-next-line no-console
    console.debug("[track]", event, payload);
  } catch (e) {
    /* noop */
  }
}

// The selected backend saves the lead and handles notification delivery.
export async function submitLead(data) {
  const payload = await createLead(data);
  track("lead_submit", { track: data.track, source: data.source });
  return payload;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
